<template>
  <div class="">
    <m-content-wrapper content-type="post" :slicer="slicer" :content-category="contentCategory"
                       :pause-if-category-not-found="true"
    >
      <template v-slot="{contents}">
        <swiper class="mySwiper py-4 w-100 "
                v-bind="swiperOptions" :pagination="true" :navigation="true" :modules="modules">

          <template v-for="content in setupContents(contents)" :key="content.id">
            <swiper-slide class="py-3">

              <m-a v-if="cardLink" :href="{name:'SinglePost',params:{slug:content.slug}}">
                <component :is="postCard" :content="content"/>
              </m-a>
              <component v-else :is="postCard" :content="content"/>


            </swiper-slide>
          </template>


        </swiper>
      </template>
    </m-content-wrapper>
  </div>
</template>

<script>
import mContentWrapper from "../../Wrappers/ContentWrapper";
import mIcon from "../../Icons/Icon";
import mA from "../../Tags/A";
import {Cards} from "../Card/Cards";
import {Swiper, SwiperSlide} from "swiper/vue";
import {EffectFade, Navigation, Pagination} from "swiper";
import {postSliderProps} from "../../Post/Slider/PostSliderProps";

export default {
  name: "PostsRelated300",
  components: {Swiper, SwiperSlide, mContentWrapper, mIcon, mA, ...Cards},
  props: {
    content: {},
    contentCategory: {
      default: null
    },
    ignoreItem: {
      default: []
    },
    itemClass: {
      default: 'col-lg-4 my-3'
    },
    slicer: {
      default: 12
    },
    postCard: {
      options: Object.keys(Cards),
      default: 'mPostCard310'
    },
    ...postSliderProps
  },
  data() {
    return {
      swiperOptions: {
        spaceBetween: 30,
        breakpoints: {
          300: {
            slidesPerView: 2,
          },
          400: {
            slidesPerView: 3,
          },
          430: {
            slidesPerView: 3,
          },
          490: {
            slidesPerView: 4,
            spaceBetween: 50,
          },
          520: {
            slidesPerView: 4,
            spaceBetween: 50,
          },
          768: {
            slidesPerView: 6,
            spaceBetween: 50,
          },
          980: {
            slidesPerView: 8,
          },
          1200: {
            slidesPerView: 8,

          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    }
  },
  setup() {
    return {
      modules: [Navigation, EffectFade, Pagination],
    };
  },
  methods: {
    findCategories(categories) {
      categories = categories.map(item => {
        return item.slug
      })
      return categories.length == 0 ? null : categories
    },
    setupContents(contents) {

      contents = contents.filter(item => {
        return this.ignoreItem.indexOf(item.id) == -1
      })

      return contents

    }
  },
  beforeMount() {

    this.swiperOptions.breakpoints["300"].slidesPerView = this.swiperPerViewSM
    this.swiperOptions.breakpoints["400"].slidesPerView = this.swiperPerViewSM
    this.swiperOptions.breakpoints["430"].slidesPerView = this.swiperPerViewSM
    this.swiperOptions.breakpoints["490"].slidesPerView = this.swiperPerViewSM

    this.swiperOptions.breakpoints["520"].slidesPerView = this.swiperPerViewMD
    this.swiperOptions.breakpoints["768"].slidesPerView = this.swiperPerViewMD

    this.swiperOptions.breakpoints["980"].slidesPerView = this.swiperPerViewLG
    this.swiperOptions.breakpoints["1200"].slidesPerView = this.swiperPerViewLG

  }
}
</script>

<style scoped>

</style>